module.exports = __webpack_public_path__ + "static/media/01_inicio_fondo_con_iconos.e2b0305b.jpg";